import cookies from "js-cookie";

var urlStyle = cookies.get("urlStyle");
var baseHost = cookies.get("baseHost");
var docHost = cookies.get("docHost");

// 正式环境域名
var productionHost = ".ulearning.cn";

// 通过地址获取域名
var host = location.host;
var isDev =
  host.indexOf("192.168") === 0 ||
  host === "127.0.0.1" ||
  host.indexOf("localhost") === 0;
var protocol = isDev ? "https://" : location.protocol + "//";
var hostDomain = isDev ? ".tongshike.cn" : host.substring(host.indexOf("."));

// cookie写入的域名
var hostname = location.hostname;

var COOKIE_DOMAIN = isDev
  ? hostname
  : hostname.substring(hostname.indexOf("."));

  
// 默认语言
var DEFAULT_LANG = "zh";

var COURSE_API_HOST = protocol + "courseapi" + hostDomain;
var CONFIG_API_HOST = protocol + "homeworkapi" + hostDomain;
var UA_API_HOST = "https://api.tongshike.cn";
var SELFWORK_WEB_HOST = protocol + "www" + hostDomain+'/selfwork';
var GROUPWORK_WEB_HOST = protocol + "www" + hostDomain + "/groupwork";
var QUIZ_WEB_HOST = protocol + "www" + hostDomain + "/quiz";

var AI_WEB = protocol + "ai" + hostDomain;

var WEB_HOST = protocol + host;
// 文档预览地址
var DOCS_HOST = docHost
  ? protocol + docHost
  : protocol + "docs" + productionHost;

// 资源访问
var RESOURCE_SERVER_HOST = protocol + "leicloud" + productionHost + "/";
var QINIU_BASE64_URL = "";
// 上传
var UPLOAD_SERVER_HOST = null;
var UPLOAD_SERVER_PROTOCOL =
  location.protocol.indexOf("https") === 0 ? "https" : "http";

// 统一身份认证
var CAS_LOGIN_URL = "";
var CAS_LOGOUT_URL = "";

if (urlStyle && urlStyle == "2") {
  baseHost = baseHost ? baseHost : host;
  COURSE_API_HOST = protocol + baseHost + "/courseapi";
  CONFIG_API_HOST = protocol + baseHost + "/homeworkapi";
  UA_API_HOST = protocol + "ua" + hostDomain + "/uaapi";
  AI_WEB = protocol + "aijx" + hostDomain;
  WEB_HOST = protocol + host;

  // 资源访问
  QINIU_BASE64_URL = "";
  // 上传
  UPLOAD_SERVER_PROTOCOL =
    location.protocol.indexOf("https") === 0 ? "https" : "http";
  // 资源上传和访问
  UPLOAD_SERVER_HOST = baseHost + "/uobs";
  RESOURCE_SERVER_HOST = protocol + baseHost + "/uobs/view";

  // 统一身份认证
  CAS_LOGIN_URL = "";
  CAS_LOGOUT_URL = "";
}


export default {
  API_HOST: CONFIG_API_HOST,
  CONFIG_API_HOST: CONFIG_API_HOST,
  COURSE_API_HOST: COURSE_API_HOST,
  QINIU_RESOURCE_URL: RESOURCE_SERVER_HOST,
  DOCS_HOST: DOCS_HOST,
  UA_API_HOST: UA_API_HOST,
  UMOOC_COOKIE_DOMAIN: COOKIE_DOMAIN,
  UPLOAD_SERVER_HOST,
  RESOURCE_SERVER_HOST,
  UPLOAD_SERVER_PROTOCOL,
  CAS_LOGIN_URL,
  CAS_LOGOUT_URL,
  AI_WEB,
  defaultLang: DEFAULT_LANG,
  SELFWORK_WEB_HOST,
  GROUPWORK_WEB_HOST,
  QUIZ_WEB_HOST
};



// WEBPACK FOOTER //
// ./src/common/config/base.js